import type {
  GetServerSideProps,
  InferGetServerSidePropsType,
  NextPage,
} from "next";
import ClientAppointmentsView, {
  TABS,
} from "@/views/client/clientAppointmentsView";

type Props = InferGetServerSidePropsType<typeof getServerSideProps>;

const HomePage: NextPage = (props: Props) => {
  return <ClientAppointmentsView initialTab={props.initialTab} />;
};

HomePage.disablePageTracking = true;

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { query } = context;
  const tabFromQuery = query.tab as string;
  const initialTab: TABS = tabFromQuery
    ? TABS[tabFromQuery.toUpperCase()]
    : TABS.APPOINTMENTS;

  if (!initialTab) {
    return {
      notFound: true,
    };
  }

  return {
    props: { initialTab },
  };
};

export default HomePage;
